import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Accessible on/off switch, bound to brand-customizable tokens so a tenant's
 * theming flows through automatically.
 *
 * DS gap: built without a Figma switch spec on hand (New Library node not
 * verified this session) - sizing/radius/motion should be checked against
 * Figma before this is treated as final.
 *
 * @example
 * <lib-anc-toggle
 *   [checked]="row.is_enabled"
 *   (checkedChange)="onToggle(row, $event)"
 * ></lib-anc-toggle>
 */
@Component({
    selector: 'lib-anc-toggle',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './anc-toggle.component.html',
    styleUrls: ['./anc-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncToggleComponent {
    checked = input<boolean>(false);
    disabled = input<boolean>(false);
    ariaLabel = input<string>('Toggle');

    checkedChange = output<boolean>();

    onChange(event: Event): void {
        if (this.disabled()) {
            return;
        }
        this.checkedChange.emit((event.target as HTMLInputElement).checked);
    }
}
